import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import socials from "../data/socials";
import './Contact.css'; 

function Contact() {
    const form = useRef();
    const [status, setStatus] = useState('');

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_r2cqu3a', 'template_wt39dri', form.current, 'fTUwcx7TTE8FVoZUl')
            .then((result) => {
                setStatus('Message sent successfully!');
                e.target.reset(); // Reset form after submission
            }, (error) => {
                setStatus('Failed to send message. Please try again.');
                console.log(error)
            });
    };
    

    return (
        <div>
            <h3 className="contact-title">Let's Reach Out</h3>
            <p className="contact-description">
                Don't be a stranger! I'm always open to new opportunities. Feel free to drop by any of the platforms below, or use the contact form to send a message directly.
            </p>
            <form ref={form} onSubmit={sendEmail} className="contact-form">
                <label htmlFor="from_name">Name</label>
                <input type="text" name="from_name" id="name" placeholder="Your Name" required />

                <label htmlFor="email">Email</label>
                <input type="email" name="email" id="email" placeholder="Your Email" required />

                <label htmlFor="subject">Subject</label>
                <input type="text" name="subject" id="subject" placeholder="Subject" required />

                <label htmlFor="message">Message</label>
                <textarea name="message" id="message" placeholder="Your Message" required></textarea>

                <button type="submit" className="contact-button">Send Message</button>
                {status && <p className="status-message">{status}</p>}
            </form>
            <footer>
                <div id="footer__left">
                    <code>
                        <span style={{ display: "inline", color: "cyan" }}>~/website-v4</span> on
                        <span style={{ display: "inline", color: "fuchsia" }}>main</span>
                    </code>
                    <code>Email: <a href={`mailto:${socials.email}`} style={{ color: 'lightblue' }}>{socials.email}</a></code>
                    <code>GitHub: <a href={socials.github} target="_blank" rel="noopener noreferrer" style={{ color: 'lightblue' }}>github.com/{socials.githubUsername}</a></code>
                    <code>LinkedIn: <a href={socials.linkedin} target="_blank" rel="noopener noreferrer" style={{ color: 'lightblue' }}>linkedin.com/in/{socials.linkedinUsername}</a></code>
                    <code>
                        Made with &lt;3 by <a href="/#connect" style={{ color: 'lightblue' }}>SwanHtetAung</a>. 
                    </code>
                </div>
            </footer>
            
            
        </div>
    );
}

export default Contact;
